import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Trello = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 256 256"
    width="24"
    height="24"
    {...props}
  >
    <rect
      width="256"
      height="256"
      rx="25"
      fill="hsl(from hsl(217 100% 40%) h s 37%)"
    />
    <rect x="32" y="32" width="84" height="176" rx="12" fill="#ffffff" />
    <rect x="140" y="32" width="84" height="120" rx="12" fill="#ffffff" />
  </svg>
);
